import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const Edit = React.lazy(() => import("../../containers/NewCars/EditContainer"));

export const newCarsRoutes: RouteObject[] = [
    {
        title: "Editar",
        path: "/new_cars/edit/:id",
        component: <Edit />,
        protected: true
    }
];